import {baseStagingConfig} from './staging.config';
import * as extendUtils from '../../../utils/object/extend.utils';
import {PrismConfigOptions} from '../environment-variables.interface';

export const baseProdConfig: PrismConfigOptions = extendUtils.deepExtend({}, [baseStagingConfig, {
  environmentName: "Prism Production Environment",
  ionicEnvName: 'prod',
}]);



// WEBPACK FOOTER //
// ./src/app/environment-variables/base/prod.config.ts